module.exports = __webpack_public_path__ + "r-s1.png?3ace05a4517e4da6cdee1b30551b67c9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/r-s1.png
// module id = 65
// module chunks = 0